import React, {useEffect, useRef, useState} from "react";
import {
    BUTTON, CLOSE,
    CREATE_QUESTION_TUTORIAL_DESC, LEARN_MORE_ABOUT_QUESTION_TYPE, OPEN_EXTERNAL_PLAYER,
    QUESTION_TYPES,
} from "../utils/constants";
import {ReactComponent as EXTERNAL} from "../images/external-purple-icon.svg";
import {ReactComponent as QUESTION_MARKER} from "../images/question_marker_purple.svg";
import { ReactComponent as ModalClose } from "../images/modal_close.svg";
import classes from "../pages/Report/Report.module.css";
import Skeleton from "react-loading-skeleton";
import useWindowDimensions from "../hooks/useWindowDimensions";
import styles from "./questions.module.css";
import {generateUUID} from "../utils/helpers";


export default function CreateQuestionVideoGuidance({questionType="MCSS"}) {
    const URL_MAPPING = {
        MCSS: "https://demo.video.yuja.com/V/Video?v=11072575&node=49127356&a=166285668",
        SA: "https://demo.video.yuja.com/V/Video?v=11072578&node=49127359&a=157824720",
        TF: "https://demo.video.yuja.com/V/Video?v=11072580&node=49127368&a=124698386",
        FITB: "https://demo.video.yuja.com/V/Video?v=11072584&node=49127390&a=175292728",
        CI: "https://demo.video.yuja.com/V/Video?v=11072569&node=49127314&a=32818730",
        WC: "https://demo.video.yuja.com/V/Video?v=11072570&node=49127330&a=175750107",
        MH: "https://demo.video.yuja.com/V/Video?v=11072571&node=49127331&a=181153166",
        RK: "https://demo.video.yuja.com/V/Video?v=11072573&node=49127333&a=60802832",
        OE: "https://demo.video.yuja.com/V/Video?v=11072574&node=49127341&a=154067260",
        IB: "https://demo.video.yuja.com/V/Video?v=11072578&node=49127359&a=157824720",
        RETRO: "https://demo.video.yuja.com/V/Video?v=11072578&node=49127359&a=157824720",
        BS: "https://demo.video.yuja.com/V/Video?v=11072578&node=49127359&a=157824720",
    }

    const [randomId, ] = useState(() => generateUUID());
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const linkRef = useRef();
    const containerRef = useRef();
    let {width: windowWidth} = useWindowDimensions();
    const [isOnLeft, setIsOnLeft] = useState(true);
    const [guidanceWindowWidth, setGuidanceWindowWidth] = useState(500);


    useEffect(() => {
        const handleGlobalClick = (event) => {
            // Check if the click occurred outside of the dropdown
            if (isOpen && containerRef.current && !containerRef.current.contains(event.target) && !linkRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            resetContainerPosition();
            document.addEventListener('click', handleGlobalClick, true);
        } else {
            setIsLoading(true);
        }
        return () => {
            document.removeEventListener('click', handleGlobalClick)
        };
    }, [isOpen]);


    useEffect(() => {
        resetContainerPosition();

    }, [windowWidth, linkRef]);


    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
                return;
            }

            if (event.key !== "Tab") {
                return;
            }

            const externalButtonEle = document.querySelector(`[data-yuja-external-id='${randomId}']`); // The expand/external button
            const closeButtonEle = document.querySelector(`[data-yuja-dialog-close-id='${randomId}']`); // New close button
            const focusedElement = document.activeElement;



            if (event.shiftKey) {
                if (focusedElement === externalButtonEle) {
                    event.preventDefault();
                    closeButtonEle.focus();
                }
            } else {
                if (focusedElement === closeButtonEle) {
                    event.preventDefault();
                    externalButtonEle.focus();
                }

            }

        };

        if (!!isOpen) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [isOpen, randomId]);

    const resetContainerPosition = () => {
        const guidanceWindowWidth = Math.min(windowWidth * 0.4, 500);
        setGuidanceWindowWidth(guidanceWindowWidth);

        const {left} = linkRef.current.getBoundingClientRect();
        let parentContainer = document.getElementsByClassName("create-question-body")[0];
        let {left: parentLeft, width: parentWidth} = parentContainer.getBoundingClientRect();

        setIsOnLeft(left + guidanceWindowWidth + 50 <= parentLeft + parentWidth);
    }

    return (
        <div className="create-question-guidance-container">
            <span

                onLoad={resetContainerPosition}
                ref={linkRef}
                className="fitb-desc"
                style={{ alignItems: "center", position: "relative", whiteSpace: "nowrap", display: "flex"}}

            >
                <span
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={`Open tutorial video`}
                    aria-haspopup="dialog"
                    aria-expanded={!!isOpen ? "true" : "false"}
                    aria-controls={randomId}
                    onClick={() => setIsOpen(!isOpen)}
                    className={`${styles.infoIcon} ${isOpen ? styles.active : ""}`}
                >
                    <QUESTION_MARKER />
                </span>


                {isOpen &&
                    <div
                        role={"dialog"}
                        id={randomId}
                        aria-label={LEARN_MORE_ABOUT_QUESTION_TYPE}
                        aria-modal="true"
                        className={`create-question-guidance ${isOnLeft ? "question-guidance-left" : "question-guidance-right"}`}
                        ref={containerRef}
                        style={{width: guidanceWindowWidth}}
                    >
                        <div className="create-question-guidance-video-container">
                            <div className="create-question-guidance-body">
                                <div className="create-question-guidance-row">
                                <span
                                    className="create-question-guidance-title">{QUESTION_TYPES[questionType]?.description}</span>
                                </div>
                                <div className="create-question-guidance-row">
                                    <span style={{color: "#42296E", fontWeight: "400", whiteSpace: "normal"}}>
                                        {CREATE_QUESTION_TUTORIAL_DESC}
                                    </span>
                                    <span
                                        tabIndex={0}
                                        role={BUTTON}
                                        aria-label={OPEN_EXTERNAL_PLAYER}
                                        data-yuja-external-id={randomId}
                                        style={{cursor: "pointer"}}
                                        onClick={() => window.open(URL_MAPPING[questionType], "blank")}
                                    >
                                        <EXTERNAL/>
                                    </span>
                                </div>
                            </div>
                            {isLoading &&
                                <div style={{
                                    width: "100%",
                                    height: guidanceWindowWidth * 9 / 16,
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 20,
                                    gap: 20
                                }}>
                                    <div style={{flex: 1}}/>
                                    <Skeleton borderRadius={10} height={25} inline={true} width={"20%"}
                                              className={classes.cardNumberSkeleton}
                                              containerClassName={classes.cardNumberSkeletonWrapper}
                                    />
                                    <Skeleton borderRadius={10} height={25} inline={true} width={"30%"}
                                              className={classes.cardNumberSkeleton}
                                              containerClassName={classes.cardNumberSkeletonWrapper}
                                    />
                                    <Skeleton borderRadius={10} height={25} inline={true} width={"50%"}
                                              className={classes.cardNumberSkeleton}
                                              containerClassName={classes.cardNumberSkeletonWrapper}
                                    />
                                    <div style={{flex: 1}}/>
                                </div>
                            }
                            <iframe
                                title={`${QUESTION_TYPES[questionType]?.description} question creation tutorial video`}
                                data-yuja-iframe-id={randomId}
                                onLoad={() => {
                                    setTimeout(() => {
                                        setIsLoading(false);
                                    }, 1000)
                                }}
                                allowFullScreen
                                style={{width: "100%", height: guidanceWindowWidth * 9 / 16, display: isLoading ? "none" : "block"}}
                                src={URL_MAPPING[questionType]}
                            />

                            <ModalClose
                                style={{zIndex: 10}}
                                role={BUTTON}
                                tabIndex={0}
                                onClick={() => setIsOpen(false)}
                                data-yuja-dialog-close-id={randomId}
                                className="modal-close"
                                aria-label={CLOSE.substring(0, -1)}
                            />

                        </div>
                    </div>
                }

            </span>

        </div>

    );
}